import isFunction from 'lodash/isFunction';
import cmp from '../../lib/cmp';
import onResize from '../../lib/dom/on-resize';
import './sm-ratio.less';



const calcRatio = (ratio, width, height) => ratio ? ratio : ((width && height) ? (height / width) : 0);


const determineIsHorizontal = (width, height) => width >= height;


const calcWidth = (area, ratio, width, isHorizontal) => {
  if (isFunction(area)) {
    area = area();
  }

  if (area && area.width && area.height) {
    if (isHorizontal) {
      return area.width;
    }
    return area.width ? Math.ceil(area.height / ratio) : null;
  }

  return width;
};

export default cmp(
  ({ ratio, width, height, area, body }) => {
    ratio = calcRatio(ratio, width, height);

    return {
      area,
      body,
      ratio,
      width: calcWidth(area, ratio, width, determineIsHorizontal(width, height))
    };
  },
  ($cmp, { ratio, width, body = '' }) => `
<div class="sm-ratio" ${width ? `style="width: ${width}px;"` : ''}>
  <div class="sm-ratio__placeholder" style="padding-bottom:${ratio * 100}%;"></div>
  <div class="sm-ratio__body">${body}</div>   
</div>
  `,
  (element, { area, width, height, ratio }) => {
    if (!isFunction(area)) {
      return [];
    }

    ratio = calcRatio(ratio, width, height);

    return [
      onResize(() => {
        element.style.width = `${calcWidth(area, ratio, width, determineIsHorizontal(width, height))}px`;
      })
    ];
  });



// WEBPACK FOOTER //
// ./src/components/sm-ratio/sm-ratio.js